import get from 'lodash/get';
import * as types from './types';
import { resolve, reject } from '../../middleware/simple-promise';

const initialState = {
  user: undefined,
  stores: [],
  currentStoreId: '',
  loading: false,
  updating: false,
  loadingStores: false
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case types.ME:
      return {
        ...state,
        loading: true
      };
    case resolve(types.ME): {
      return {
        ...state,
        loading: false,
        user: payload,
        stores: payload.stores,
        currentStoreId: get(payload, 'stores.0.storeId', '')
      };
    }
    case reject(types.ME):
      return {
        ...state,
        loading: false,
      };
    case types.UPDATE_USER:
      return {
        ...state,
        updating: true
      };
    case resolve(types.UPDATE_USER):
      return {
        ...state,
        updating: false,
        user: payload
      };
    case reject(types.UPDATE_USER):
      return {
        ...state,
        updating: false,
      };
    case types.STORES:
      return {
        ...state,
        loadingStores: true
      };
    case resolve(types.STORES):
      return {
        ...state,
        stores: payload,
        loadingStores: false
      };
    case types.SELECT_STORE:
      return {
        ...state,
        currentStoreId: payload
      };
    case resolve(types.DISCONNECT_STORE):
      return {
        ...state,
        stores: state.stores.filter(s => s.storeId !== meta.id),
        currentStoreId: null
      };
    case resolve(types.UPDATE_PREFERENCES):
      return {
        ...state,
        user: {
          ...state.user,
          preferences: meta.data
        }
      };
    case types.LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
};
